import React, { useCallback, useEffect, useState } from 'react';
import { Select } from 'antd';
import { useAuth } from '../../context/authContext';
import { getDownloadWidgets } from '../../utils/fixedWidgets';
import { Widget } from '../../pages/UserGroupsPage';

interface FilterUsergroupWidgetsProps {
  setSelectedWidgets: React.Dispatch<
    React.SetStateAction<Widget[] | undefined>
  >;
}

const FilterDownloadWidgets: React.FC<FilterUsergroupWidgetsProps> = ({
  setSelectedWidgets,
}) => {
  const authContext = useAuth();
  const { user } = authContext;

  const [selectedWidget, setSelectedWidget] = useState<string>('');

  const [allDownloadWidgets, setAllDownloadWidgets] = useState<Widget[]>([]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedId = Number(urlParams.get('id')) ?? undefined;

    const downloadWidgets = getDownloadWidgets(
      user?.selectedUsergroup?.settings?.widgets?.children ?? [],
    );
    setAllDownloadWidgets(downloadWidgets);

    // todo verifricar se quanod muda o usergroup aqui deve resetar o query params
    if (selectedId) {
      const selectedDownloadWidget = downloadWidgets.find(
        widget => widget.widgetId === selectedId,
      );

      if (selectedDownloadWidget) {
        setSelectedWidget(selectedDownloadWidget.name);
      }
    } else {
      setSelectedWidget('');
    }
  }, [setSelectedWidgets, user.selectedUsergroup]);

  const handleDownloadWidgetChange = useCallback(
    async (value: any): Promise<void> => {
      const urlParams = new URLSearchParams(window.location.search);
      if (!value) {
        urlParams.delete('id');
        setSelectedWidgets([]);
      } else {
        // update the page query params "name" to be widgetName
        urlParams.set('id', value);
        setSelectedWidgets([value]);
      }
      setSelectedWidget(value);

      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${urlParams}`,
      );
    },
    [setSelectedWidgets],
  );

  const selectOptions = allDownloadWidgets.map((widget: Widget) => ({
    value: widget.widgetId,
    label: <span>{widget.name}</span>,
  }));

  return (
    <Select
      style={{ width: '25%', height: '100%' }}
      value={selectedWidget}
      onChange={handleDownloadWidgetChange}
      optionLabelProp="label"
      options={selectOptions}
      // translate to german
      placeholder="Select widget"
      allowClear={true}
    />
  );
};

export default FilterDownloadWidgets;
